import TransferCommonDetails from './TransferCommonDetails';

export default TransferCommonDetails;
